<template>
  <v-col cols="12">
    <v-row>
      <v-col cols="12" md="5" order="2" order-md="1">
        <h3 class="pt-4">Ad Text</h3>
        <v-divider/>
        <v-col cols="12">
          <h3 class="pt-4">Text</h3>
          <v-textarea
            prepend-icon="title"
            :value="text"
            @input="setText"
          />
        </v-col>

        <v-col cols="12">
          <h3>Headline</h3>
          <v-textarea
            prepend-icon="edit"
            :value="headline"
            @input="setHeadline"
          />
        </v-col>

        <v-col cols="12">
          <h3>Displayed link URL (optional)</h3>
          <v-text-field
            prepend-icon="link"
            :value="displayLink"
            @input="setDisplayLink"
          />
        </v-col>

        <v-col cols="12">
          <h3>Description (appears in some placements)</h3>
          <v-text-field
            :value="description"
            @input="setDescription"
          />
        </v-col>

        <v-col cols="12">
          <h3>Call to action</h3>
          <v-select
            :items="buttons"
            v-model="callToAction"
          />
        </v-col>

      </v-col>
      <v-col order="1" order-md="2">
        <h3 class="pt-4">Preview</h3>
        <v-divider/>
        <div
          v-if="preview && !previewLoading"
          class="preview-iframe mt-3"
        >
          <div class="resp-container" v-html="preview" />
        </div>
        <v-card
          v-else-if="setupMode"
          text
          dark
          color="grey"
          max-width="502"
          height="350"
          class="mt-3"
        >
          <div class="preview-placeholder">
            <v-icon>add_a_photo</v-icon>
          </div>
        </v-card>
        <v-card
          v-else
          text
          dark
          color="grey"
          max-width="502"
          height="350"
          class="mt-3"
        >
          <v-progress-linear :indeterminate="true"></v-progress-linear>
          <div class="preview-placeholder">
            <div class="headline">Updating preview ...</div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: 'upload-image-preview-block',
  data () {
    return {
      buttons: [
        {
          text: 'NO BUTTON'
        },
        {
          text: 'LEARN MORE'
        },
        {
          text: 'SIGN UP'
        },
        {
          text: 'SUBSCRIBE'
        },
        {
          text: 'CONTACT US'
        },
        {
          text: 'DONATE NOW'
        }
      ],
      callToAction: 'LEARN MORE',
      timeout: null
    }
  },
  props: {
    reviewFileUrl: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: 'Enter your ad text here'
    },
    headline: {
      type: String,
      default: null
    },
    displayLink: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    preview: {
      type: String,
      default: null
    },
    previewLoading: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.validation()
    this.$emit('setMessageFields', this.callToAction, 'callToAction', true)
  },
  computed: {
    setupMode () {
      const setupMode = this.$store.getters.getSetupMode
      return setupMode ? setupMode.status : false
    }
  },
  methods: {
    validation () {
      if (this.text && this.headline) this.$emit('setConfirmActive', true)
    },
    setText (value) {
      this.validation()
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.$emit('setMessageFields', value, 'text', true)
        clearTimeout(this.timeout)
      }, 1000)
    },
    setHeadline (value) {
      this.validation()
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.$emit('setMessageFields', value, 'headline', true)
        clearTimeout(this.timeout)
      }, 1000)
    },
    setDisplayLink (value) {
      this.validation()
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.$emit('setMessageFields', value, 'displayLink', true)
        clearTimeout(this.timeout)
      }, 1000)
    },
    setDescription (value) {
      this.validation()
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.$emit('setMessageFields', value, 'description', true)
        clearTimeout(this.timeout)
      }, 1000)
    }
  },
  watch: {
    callToAction (val) {
      this.$emit('setMessageFields', val, 'callToAction', true)
    }
  }
}
</script>
<style lang="scss">
  .preview-iframe {
    position: -webkit-sticky;
    position: sticky;
    top: 65px;
    height: auto;
    max-height: 600px;
    overflow: hidden;
  }
  .v-btn--absolute.v-btn--top {
    top: 0!important;
    right: 0!important;
  }
  .resp-container {
    position: relative;
    padding-top: 100%;
      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
      }
  }
  .preview-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10rem;
  }
</style>
